module.exports = __webpack_public_path__ + "static/media/emiratescard.555ee3a8.gif";